import styled from "styled-components"

const ContentContainer = styled.div`
  color: inherit;
  .carouselContainer:hover {
    > button {
      opacity: 1;
    }
  }
`

export { ContentContainer }
